import React, { useCallback } from "react"
import PropTypes from "prop-types"
import { Bar } from "react-chartjs-2"
import { useTranslation } from "react-i18next"
import Config from "assets/configs/score.js"
import { DEFAULT_OPTIONS } from "services/charts/default"

const MatchingBreakdownBarStackedChartAtom = ({
  chartData = { datasets: [], labels: [] },
  labelTranslationFunction = (label) => label,
  contextType,
}) => {
  const { t } = useTranslation()

  const getBackgroundColors = useCallback((context) => {
    const baseColors = {
      green: Config.common.colorsEvaluation.green,
      yellow: Config.common.colorsEvaluation.yellow,
      neutral: Config.common.colors[0],
    }

    return context === "purchases"
      ? [baseColors.green, baseColors.yellow]
      : [baseColors.green, baseColors.neutral, baseColors.yellow]
  }, [])

  const generateData = useCallback(() => {
    const translatedEquipmentTypes = chartData.labels?.map(
      labelTranslationFunction
    )

    const backgroundColors = getBackgroundColors(contextType)

    const datasets = chartData.datasets.map((dataset, index) => ({
      label: t(`collect:qualities.${contextType}.analytics.${dataset.label}`),
      data: dataset.data,
      count: dataset.count,
      backgroundColor: backgroundColors[index % backgroundColors.length],
      stack: 1,
    }))

    let resultats = []

    for (let i = 0; i < datasets[0].data.length; i++) {
      let somme = _.sumBy(datasets, (dataset) => dataset.data[i])
      resultats.push(somme)
    }

    const valueMax = Math.max(...resultats)

    datasets.Max = valueMax

    return {
      labels: translatedEquipmentTypes,
      datasets: datasets,
    }
  }, [chartData])
  return <Bar options={DEFAULT_OPTIONS} data={generateData()} />
}

MatchingBreakdownBarStackedChartAtom.propTypes = {
  chartData: PropTypes.object,
  labelTranslationFunction: PropTypes.func,
  contextType: PropTypes.string,
}

export default MatchingBreakdownBarStackedChartAtom
